
















import { computed, defineComponent, ref } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { BaseMenuItem } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseMenu from "@/components/BaseMenu";
import BaseSpinner from "@/components/BaseSpinner";

enum ProfileFeedFiltersType {
  NEWEST = "newest",
  TOP_SELLING = "top-selling",
}

export default defineComponent({
  name: "ProfileFeedFilters",
  components: { BaseSpinner, BaseIcon, BaseMenu },
  props: {
    isFeedView: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  setup(_, { emit }) {
    const activeType = ref<ProfileFeedFiltersType>(ProfileFeedFiltersType.NEWEST);

    const filterItems = computed<BaseMenuItem[]>(() => {
      return [
        {
          text: $t("Newest"),
          name: ProfileFeedFiltersType.NEWEST,
          value: null,
          class: activeType.value === ProfileFeedFiltersType.NEWEST ? "__active" : "",
        },
        {
          text: $t("Top-selling"),
          name: ProfileFeedFiltersType.TOP_SELLING,
          value: "SALES_AMOUNT,DESC;PUBLISH_TIME,DESC",
          class: activeType.value === ProfileFeedFiltersType.TOP_SELLING ? "__active" : "",
        },
      ];
    });

    const activeFilter = computed(
      () => filterItems.value.find(i => i.name === activeType.value) || filterItems.value[0]
    );

    const onSubmitFilter = (name: ProfileFeedFiltersType) => {
      if (name === activeType.value) return;
      activeType.value = name;
      emit("updateSorting", activeFilter.value.value);
    };

    return { filterItems, activeFilter, onSubmitFilter };
  },
});
